import React, { forwardRef, useEffect, useState } from "react";
import moment from "moment-timezone";
import PropTypes from "prop-types";

import { Datepicker as BaseDatepicker } from "@/ui-lib/FormFields/Datepicker";
import { getCompanyDateFormat2Digit } from "@/utils/date";

const RangeDateTimepicker = forwardRef(
  (
    {
      className,
      onChange,
      placeholder,
      startDate,
      endDate,
      select,
      rangeStartLabel,
      rangeEndLabel,
      ...rest
    },
    ref
  ) => {
    const [start, setStart] = useState(
      startDate ? moment(startDate).format(`${getCompanyDateFormat2Digit()} hh:mm A`) : null
    );
    const [end, setEnd] = useState(endDate ? moment(endDate).format(`${getCompanyDateFormat2Digit()} hh:mm A`) : null);

    // useEffect(() => {
    //   setStart(startDate);
    //   setEnd(endDate);
    // }, [startDate, endDate]);

    return (
      <BaseDatepicker
        className={className}
        value={[start, end]}
        dateFormat={getCompanyDateFormat2Digit()}
        timeFormat="hh:mm A"
        themeVariant="light"
        controls={["calendar", "time"]}
        theme="ios"
        select={select}
        rangeStartLabel={rangeStartLabel}
        rangeEndLabel={rangeEndLabel}
        onChange={(data) => {
          const { value } = data;
          if (data.valueText === "") return;
          if (select === "range") {
            const startDateValue =
              value && value[0] ? moment(value[0]).format(`${getCompanyDateFormat2Digit()} hh:mm A`) : null;
            const endDatevalue =
              value && value[1] ? moment(value[1]).format(`${getCompanyDateFormat2Digit()} hh:mm A`) : null;

            if (startDateValue) {
              setStart(startDateValue);
            }
            if (endDatevalue) {
              setEnd(endDatevalue);
            }

            if (startDateValue && endDatevalue) {
              onChange({
                startDate: startDateValue,
                endDate: endDatevalue,
              });
            }
          }
        }}
        placeholder={placeholder}
        ref={ref}
        {...rest}
      />
    );
  }
);

RangeDateTimepicker.defaultProps = {
  className: "",
  placeholder: "",
  select: "date",
  rangeStartLabel: "From",
  rangeEndLabel: "To",
  startDate: "",
  endDate: "",
};

RangeDateTimepicker.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  select: PropTypes.oneOf(["date", "range"]),
  rangeStartLabel: PropTypes.string,
  rangeEndLabel: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

export default RangeDateTimepicker;
